export default __webpack_public_path__ + "static/media/purple-loader.69ff723a.gif";